// public/js/features/feedback/util.js
import { escapeHtml } from '../../utils/escape.js';

// Minimal, safe Markdown: escape first, then apply a few inline patterns. No raw
// HTML can survive (everything is escaped before formatting).
export function renderMarkdown(src) {
  let s = escapeHtml(src || '');
  s = s.replace(/`([^`]+)`/g, '<code>$1</code>');
  s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  s = s.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>');
  // [text](https://url)
  s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
  // bare http(s) urls not already inside an anchor
  s = s.replace(/(^|\s)(https?:\/\/[^\s<]+)/g, '$1<a href="$2" target="_blank" rel="noopener">$2</a>');
  s = s.replace(/\n/g, '<br>');
  return s;
}

// ── auto-context capture (attached to bug reports) ───────────────────────────
const _errors = [];
function pushErr(m) {
  _errors.push({ t: new Date().toISOString(), m: String(m).slice(0, 300) });
  if (_errors.length > 12) _errors.shift();
}
// Installed once on import.
window.addEventListener('error', (e) => pushErr(`${e.message} @ ${e.filename}:${e.lineno}:${e.colno}`));
window.addEventListener('unhandledrejection', (e) => pushErr(`unhandledrejection: ${e.reason?.message || e.reason}`));

export function captureContext() {
  return {
    appVersion: window.APP_CONFIG?.ASSET_VERSION || null,
    route: location.hash || '/',
    userAgent: navigator.userAgent,
    viewport: `${window.innerWidth}×${window.innerHeight}`,
    language: navigator.language,
    time: new Date().toISOString(),
    recentErrors: _errors.slice(-5),
  };
}

export function relativeTime(iso) {
  if (!iso) return '';
  const ms = Date.now() - new Date(iso).getTime();
  const s = Math.round(ms / 1000);
  if (s < 60) return 'just now';
  const m = Math.round(s / 60); if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60); if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24); if (d < 30) return `${d}d ago`;
  return new Date(iso).toLocaleDateString(navigator.language);
}

export const STATUS_BADGE = {
  open: 'secondary', acknowledged: 'info', in_progress: 'primary', planned: 'info',
  resolved: 'success', released: 'success', closed: 'dark', wontfix: 'warning', duplicate: 'warning',
};
export const PRIORITY_BADGE = { low: 'light text-dark', normal: 'secondary', high: 'warning', critical: 'danger' };
export const TYPE_BADGE = { report: 'secondary', fix: 'primary', feature: 'success' };
